import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useAiResponding = (): IGlobalStore['ai_responding'] => {
  return useSelector((store: IReducerStore) => store.global.ai_responding);
};
